import { DictType } from "@pma/types";

import { Card, CardContent, CardTitle } from "@components/common/card";
import { Separator } from "@components/common/separator";
import TaskCard from "../projects/task-card";
import ProjectCard from "../projects/project-card";
import { NoteCard } from "../projects/notes-card";
import { FileCard } from "../files/file-card";
import useTranslator from "@hooks/use-translator";

interface Props {
  setIsOpen: CallableFunction;
  results: DictType;
}
const SearchResults = ({ results, setIsOpen }: Props) => {
  const { translate } = useTranslator();
  const { title: taskTitle, items: tasks } = results?.tasks;
  const { title: projectTitle, items: projects } = results?.projects;
  const { title: notesTitle, items: notes } = results?.notes;
  const { title: filesTitle, items: files } = results?.files;

  return (
    <div className="flex flex-col">
      {tasks.length > 0 && (
        <Card className="border-0 shadow-none pb-4">
          <CardContent className="flex flex-col gap-3">
            <CardTitle>
              {translate(taskTitle)}- {tasks?.length} {translate("found")}
            </CardTitle>
            <div className="grid md:grid-cols-3 gap-4 w-full">
              {tasks?.map((task: any, index: number) => (
                <TaskCard task={task?.item} key={task?.id} />
              ))}
            </div>
          </CardContent>
          <Separator />
        </Card>
      )}

      {/* Projects Results */}

      {projects.length > 0 && (
        <Card className="border-0 shadow-none pb-4">
          <CardContent className="flex flex-col gap-3">
            <CardTitle>
              {translate(projectTitle)} - {projects?.length}{" "}
              {translate("found")}
            </CardTitle>

            <div className="grid md:grid-cols-3 gap-4">
              {projects?.map((project: any, index: number) => (
                <ProjectCard project={project?.item} key={project?.id} />
              ))}
            </div>
          </CardContent>
          <Separator />
        </Card>
      )}

      {/* Notes Results */}
      {notes?.length > 0 && (
        <Card className="border-0 shadow-none pb-4">
          <CardContent className="flex flex-col gap-3">
            <CardTitle>
              {translate(notesTitle)} - {notes?.length} {translate("found")}
            </CardTitle>

            <div className="grid md:grid-cols-4 gap-4">
              {notes?.map((note: any) => (
                <NoteCard note={note?.item} key={note?.id} />
              ))}
            </div>
          </CardContent>
          <Separator />
        </Card>
      )}

      {/* Files Results */}
      {files.length > 0 && (
        <Card className="border-0 shadow-none pb-4">
          <CardContent className="flex flex-col gap-3">
            <CardTitle>
              {translate(filesTitle)} - {files.length} {translate("found")}
            </CardTitle>

            <div className="grid md:grid-cols-4 gap-4">
              {files?.map((file: any) => (
                <FileCard file={file?.item} key={file?.id} />
              ))}
            </div>
          </CardContent>
          <Separator />
        </Card>
      )}
    </div>
  );
};

export default SearchResults;
